import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import BookPage from "@/pages/BookPage";
import AboutPage from "@/pages/AboutPage";
import PressPage from "@/pages/PressPage";
import ContactPage from "@/pages/ContactPage";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import { PageTransition } from "@/components/Motion";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      window.requestAnimationFrame(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      });
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function Shell({ children }) {
  return (
    <div className="App paper-grain" data-testid="site-root">
      <Nav />
      <main className="pt-24 md:pt-28">
        <PageTransition>{children}</PageTransition>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1C1C1A",
            color: "#F9F6F0",
            border: "1px solid #1C1C1A",
            borderRadius: "0px",
            fontFamily: "'Manrope', sans-serif",
            fontSize: "0.78rem",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
          },
        }}
      />
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/book" element={<Shell><BookPage /></Shell>} />
          <Route path="/about" element={<Shell><AboutPage /></Shell>} />
          <Route path="/press" element={<Shell><PressPage /></Shell>} />
          <Route path="/contact" element={<Shell><ContactPage /></Shell>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
